<template>
  <div class="editGallery">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        平台信息
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="flush()">刷新</div>
        </div>
      </div>
    </div>
    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="table">
        <div class="table_left">
          <div class="left_div">
            <i class="fas fa-bookmark fa-lg" style="margin-left:30px;color:white"></i>
            <div class="positi"></div>
            <p>常规设置</p>
          </div>
        </div>
        <el-form
          :label-position="labelPosition"
          label-width="220px"
          :model="formLabelAlign"
          style="padding-top:30px"
        >
          <el-form-item label="站点名称">
            <el-input v-model="formLabelAlign.website_name"></el-input>
          </el-form-item>
          <el-form-item label="公司名称">
            <el-input style="width:300px" v-model="formLabelAlign.comp_name"></el-input>
          </el-form-item>
          <el-form-item label="公司地址">
            <el-input v-model="formLabelAlign.address"></el-input>
          </el-form-item>
          <el-form-item label="平台logo">
            <div style="display:flex">
              <div v-show="show1" style="margin-right:8px">
                <img width="148" height="148" :src="serve+'/' + formLabelAlign.logo" alt />
              </div>
              <el-upload
                action
                list-type="picture-card"
                :on-change="handleRemove1"
                :auto-upload="false"
                :limit="1"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>

            <!-- <input
              type="file"
              id="file"
              accept="image/png, image/jpeg, image/jpg"
              @change="getImage($event)"
            >-->
          </el-form-item>
          <el-form-item label="微信公众号">
            <!-- <el-input v-model="formLabelAlign.wx_gzh"></el-input> -->
            <div style="display:flex">
              <div v-show="show2" style="margin-right:8px">
                <img width="148" height="148" :src="serve+'/' + wx_gzh_img" alt />
              </div>
              <el-upload
                action
                list-type="picture-card"
                :on-change="handleRemove2"
                :auto-upload="false"
                :limit="1"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="官方微信图片">
            <!-- <el-input v-model="formLabelAlign.wx_gzh"></el-input> -->
            <div style="display:flex">
              <div v-show="show3" style="margin-right:8px">
                <img width="148" height="148" :src="serve+'/' + guanwei_img" alt />
              </div>
              <el-upload
                action
                list-type="picture-card"
                :on-change="handleRemove3"
                :auto-upload="false"
                :limit="1"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="客服电话">
            <el-input v-model="formLabelAlign.service_mobile"></el-input>
          </el-form-item>
          <el-form-item label="客服邮箱">
            <el-input v-model="formLabelAlign.service_email"></el-input>
          </el-form-item>
          <el-form-item label="网站版权">
            <el-input v-model="formLabelAlign.copyright"></el-input>
          </el-form-item>
          <el-form-item label="商城版本">
            <el-input v-model="formLabelAlign.versions"></el-input>
          </el-form-item>
          <el-form-item label="ICP备案">
            <el-input v-model="formLabelAlign.ICP"></el-input>
          </el-form-item>

          <el-form-item label="新浪微博">
            <el-input v-model="formLabelAlign.wb"></el-input>
          </el-form-item>
          <el-form-item label="股票交易代码">
            <el-input v-model="formLabelAlign.stock_trading_code"></el-input>
          </el-form-item>
          <el-form-item label="人力资源邮箱">
            <el-input v-model="formLabelAlign.hr_email"></el-input>
          </el-form-item>
          <el-form-item label="邮政编码">
            <el-input v-model="formLabelAlign.postcode"></el-input>
          </el-form-item>
          <el-form-item label="公司QQ">
            <el-input v-model="formLabelAlign.comp_QQ"></el-input>
          </el-form-item>
          <el-form-item label="公司邮箱">
            <el-input v-model="formLabelAlign.comp_email"></el-input>
          </el-form-item>
          <el-form-item label="公司电话">
            <el-input v-model="formLabelAlign.comp_mobile"></el-input>
          </el-form-item>
          <el-form-item label="合作洽谈">
            <el-input v-model="formLabelAlign.collaborate"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="button" @click="submit()">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      wx_gzh_img: "",
      guanwei_img: "",
      show1: true,
      show2: true,
      show3: true,
      labelPosition: "right",

      formLabelAlign: {
        logo: "",
        username: "",
        token: "",
        ICP: "",
        address: "",
        collaborate: "",
        comp_QQ: "",
        comp_email: "",
        comp_mobile: "",
        comp_name: "",
        copyright: "",
        hr_email: "",
        postcode: "",
        service_email: "",
        service_mobile: "",
        stock_trading_code: "",
        versions: "",
        wb: "",
        website_name: "",
        wx_gzh: "",
        id: "",
        newImage: null,
        newImage2: null,
        newImage3: null
      }
    };
  },
  created() {
    this.$store.state.topActiveId = 7;
    this.$store.state.leftTitle = "平台信息";
    this.flush();
  },
  methods: {
    handleRemove1(file, fileList) {
      this.show1 = false;
      this.formLabelAlign.newImage = file.raw;
    },
    handleRemove2(file, fileList) {
      this.show2 = false;
      this.formLabelAlign.newImage2 = file.raw;
    },
    handleRemove3(file, fileList) {
      this.show3 = false;
      this.formLabelAlign.newImage3 = file.raw;
    },
    flush() {
      const that = this;
      this.formLabelAlign.username = this.$cookies.get("username");
      this.formLabelAlign.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/webget_info", {
          params: {
            username: this.formLabelAlign.username,
            token: this.formLabelAlign.token
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            const json = res.data.data;
            that.formLabelAlign.ICP = json.ICP;
            that.formLabelAlign.address = json.address;
            that.formLabelAlign.collaborate = json.collaborate;
            that.formLabelAlign.comp_QQ = json.comp_QQ;
            that.formLabelAlign.comp_email = json.comp_email;
            that.formLabelAlign.comp_mobile = json.comp_mobile;
            that.formLabelAlign.comp_name = json.comp_name;
            that.formLabelAlign.copyright = json.copyright;
            that.formLabelAlign.hr_email = json.hr_email;
            that.formLabelAlign.postcode = json.postcode;
            that.formLabelAlign.service_email = json.service_email;
            that.formLabelAlign.service_mobile = json.service_mobile;
            that.formLabelAlign.stock_trading_code = json.stock_trading_code;
            that.formLabelAlign.versions = json.versions;
            that.formLabelAlign.wb = json.wb;
            that.formLabelAlign.website_name = json.website_name;
            that.formLabelAlign.wx_gzh = json.wx_gzh;
            that.formLabelAlign.id = json.id;
            that.formLabelAlign.logo = json.logo;
            that.wx_gzh_img = json.wx_gzh_img;
            that.guanwei_img = json.guanwei_img;
          }else{
            if(res.data.msg == "无权访问"){
              this.role = false
            }
          }
        });
    },
    getImage(e) {
      this.formLabelAlign.newImage = e.target.files[0];
    },
    submit() {
      var that = this;
      this.formLabelAlign.username = this.$cookies.get("username");
      this.formLabelAlign.token = this.$cookies.get("token");
      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };

      const formData = new FormData();
      formData.append("username", this.formLabelAlign.username);
      formData.append("info", this.formLabelAlign.info);
      formData.append("token", this.formLabelAlign.token);
      formData.append("logo", this.formLabelAlign.newImage);
      formData.append("wx_gzh_img", this.formLabelAlign.newImage2);
      formData.append("official_wx", this.formLabelAlign.newImage3);
      formData.append("id", this.formLabelAlign.id);
      formData.append("ICP", this.formLabelAlign.ICP);
      formData.append("address", this.formLabelAlign.address);
      formData.append("collaborate", this.formLabelAlign.collaborate);
      formData.append("comp_QQ", this.formLabelAlign.comp_QQ);
      formData.append("comp_email", this.formLabelAlign.comp_email);
      formData.append("comp_mobile", this.formLabelAlign.comp_mobile);
      formData.append("comp_name", this.formLabelAlign.comp_name);
      formData.append("copyright", this.formLabelAlign.copyright);
      formData.append("hr_email", this.formLabelAlign.hr_email);
      formData.append("postcode", this.formLabelAlign.postcode);
      formData.append("service_email", this.formLabelAlign.service_email);
      formData.append("service_mobile", this.formLabelAlign.service_mobile);
      formData.append(
        "stock_trading_code",
        this.formLabelAlign.stock_trading_code
      );
      formData.append("versions", this.formLabelAlign.versions);
      formData.append("wb", this.formLabelAlign.wb);
      formData.append("website_name", this.formLabelAlign.website_name);
      formData.append("wx_gzh", this.formLabelAlign.wx_gzh);
      this.axios
        .post(this.serve + "/admin/webset_info", formData, config)
        .then(res => {
          if (res.data.status == "success") {
            loading.close();
            this.$message({
              type: "success",
              message: "提交成功"
            });
          }else if(res.data.code == '403'){
            this.$message.error(res.data.msg); 
          }  else if (res.data.status == "error") {
            loading.close();
            this.$message.error("操作失败");
          }
        });
    }
  }
};
</script>
<style lang="scss">
.editGallery {
  background: #f5f5f5;
  color: #333;
  // height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }

  textarea {
    height: 300px;
  }
  .form-title {
    background-color: #eee;
    border: 1px solid #ddd;
  }
  .table {
    background-color: #fff;
  }
  .row {
    margin-bottom: 20px;
  }
  .form {
    width: 450px;
    margin: 0 auto;
    padding: 20px 0;
    align-items: right;
  }
  .table {
    display: flex;
  }
  .table_left {
    width: 182px;
    // height: 1418px;
    background: rgba(238, 238, 238, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: relative;
    .left_div {
      width: 182px;
      height: 54px;
      background: rgba(166, 182, 193, 1);
      position: absolute;
      left: 0;
      top: 130px;
      display: flex;
      position: relative;
      align-items: center;
      .positi {
        width: 0;
        height: 0;
        border-top: 27px dashed transparent;
        border-bottom: 27px dashed transparent;
        border-left: 24px solid rgba(166, 182, 193, 1);
        font-size: 0;
        position: absolute;
        top: 0;
        right: -24px;
      }

      > p {
        // display: inline-block;
        margin-left: 6px;
        font-size: 18px;
        font-family: "MicrosoftYaHei";
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }
    }
  }
  .label {
    line-height: 40px;
  }
  .button {
    width: 190px;
    height: 44px;
    background: rgba(0, 153, 255, 1);
    border-radius: 4px;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  .button:hover {
    background: rgba(46, 172, 255, 1);
  }
  // input{
  //   width: 178%;
  // }
  .notice {
    font-size: 13px;
    color: #666;
  }
}
</style>
